import { calculateRawAudioFrameBufferSize, calculateSampleCountForFrameNumber, calculateSampleOffsetForFrameNumber } from '@mimir/common/transcoding/rawFrame';
import type { AudioFrameV2, FrameV2 } from './frameProvider';
import { invariant } from '@mimir/common/util/invariant';

export function closeFrame(frame: FrameV2 | null): void {
  frame?.video?.buffer.close();
  frame?.audio?.buffer.close();
}


export function validateAudioFrame(audioFrame: AudioFrameV2) {
  const expectedBufferSize = calculateRawAudioFrameBufferSize(audioFrame, audioFrame.sampleCount);
  invariant(audioFrame.buffer.size() === expectedBufferSize, `Frame validation failed. Expected audioBufferSize to be ${expectedBufferSize} but it is ${audioFrame.buffer.size()}`);
}

export function validateFrame(frame: FrameV2) {
  if (frame.audio !== null) {
    const expectedSampleCount = calculateSampleCountForFrameNumber(frame.audio.sampleRate, frame.frameRate, frame.frameNumber);
    const expectedSampleOffset = calculateSampleOffsetForFrameNumber(frame.audio.sampleRate, frame.frameRate, frame.frameNumber);
    invariant(frame.audio.sampleCount === expectedSampleCount, `Frame validation failed. Expected sampleCount to be ${expectedSampleCount} for frame number ${frame.frameNumber}, but it is ${frame.audio.sampleCount}`);
    invariant(frame.audio.sampleOffset === expectedSampleOffset, `Frame validation failed. Expected sampleOffset to be ${expectedSampleOffset} for frame number ${frame.frameNumber}, but it is ${frame.audio.sampleOffset}`);
    validateAudioFrame(frame.audio);
  }
  invariant(frame.frameRate.numerator !== 0, 'Frame rate is zero.');
  invariant(frame.frameRate.numerator > 0, 'Frame rate numerator is negative.');
  invariant(frame.frameRate.denominator !== 0, 'Frame rate numerator is zero.');
  invariant(frame.frameRate.denominator > 0, 'Frame rate numerator is negative.');
}
